"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SNSMessageAttributeEvents;
(function (SNSMessageAttributeEvents) {
    SNSMessageAttributeEvents["PASSWORD_RESET"] = "passwordReset";
    SNSMessageAttributeEvents["REMINDER_STANDING_ORDER"] = "reminderStandingOrder";
    SNSMessageAttributeEvents["SUBSCRIPTION_MANAGEMENT"] = "subscriptionManagement";
    SNSMessageAttributeEvents["WALLET_UPDATE"] = "walletUpdate";
    SNSMessageAttributeEvents["PROFILE_UPDATES_THIRD_PARTIES_ALL"] = "upsertAll";
    SNSMessageAttributeEvents["PROFILE_PEGA"] = "upsertPega";
    SNSMessageAttributeEvents["PROFILE_WSPA"] = "upsertWSPA";
    SNSMessageAttributeEvents["PROFILE_ZUORA"] = "upsertZuora";
    SNSMessageAttributeEvents["PROFILE_OKTA"] = "profileOkta";
    SNSMessageAttributeEvents["PROFILE_MEDIUS"] = "profileMedius";
    SNSMessageAttributeEvents["PROFILE_MERIDIAN"] = "profileMeridian";
    SNSMessageAttributeEvents["PROFILE_EXTENSION_ENGINE"] = "profileExtensionEngine";
    SNSMessageAttributeEvents["PROFILE_UNIQUEST"] = "upsertUniQuest";
    SNSMessageAttributeEvents["PROFILE_TWTCPA"] = "profileTWTCPA";
    SNSMessageAttributeEvents["PROFILE_PEARSONVUE"] = "profilePearsonVue";
    SNSMessageAttributeEvents["CREATE_CERT_ESFA"] = "createCertESFA";
    SNSMessageAttributeEvents["EXAM_FLP"] = "examFLP";
    SNSMessageAttributeEvents["SF_PLATFORM"] = "sfPlatform";
    SNSMessageAttributeEvents["EXAM_CREDIT"] = "examCredit";
    SNSMessageAttributeEvents["PROFILE_FLP"] = "profileFLP";
})(SNSMessageAttributeEvents = exports.SNSMessageAttributeEvents || (exports.SNSMessageAttributeEvents = {}));
var EventDetailType;
(function (EventDetailType) {
    EventDetailType["SCHEDULED"] = "Scheduled Event";
    EventDetailType["HEALTH"] = "AWS Health Event";
})(EventDetailType = exports.EventDetailType || (exports.EventDetailType = {}));
//# sourceMappingURL=index.js.map